<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search">
                                    <Input class="search-input" size="small" clearable v-model="search.title" placeholder="采购标题" />
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.small_project_id" clearable filterable placeholder="零星项目">
                                        <Option :value="item.small_project_id" v-for="(item,index) in projectList" :key="index">{{item.customer_name ? item.name + '（' + item.customer_name + '）' : item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.maintain_id" clearable filterable placeholder="维保记录">
                                        <Option :value="item.maintain_id" v-for="(item,index) in maintainList" :key="index">{{item.title}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.company_id" clearable filterable placeholder="供应商">
                                        <Option :value="item.company_id" v-for="(item,index) in companyList" :key="index">{{item.company}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.product" clearable filterable placeholder="采购产品">
                                        <Option :value="item.b_id" v-for="(item,index) in productList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.head_id" clearable filterable placeholder="负责人">
                                        <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">{{item.real_name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select size="small" v-model="search.status" clearable filterable placeholder="状态" class="search-select">
                                        <Option :value="item.id" v-for="(item,index) in statusList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Button size="small" @click="onSearch"><Icon type="ios-search" /> 搜索</Button>
                                </div>
                                <div class="rx-list-header-btn">
                                    <ButtonGroup>
                                        <Button type="primary" size="small" class="text-font-sm" @click="createData"><Icon type="md-add" /> 创建采购</Button>
                                        <Button type="warning" size="small" class="text-font-sm" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="buyer_id" stripe border :loading="$store.state.loading" :columns="columns" :data="dataList.data" no-data-text="暂无数据记录">
                                <template #title="{ row }">
                                    <div class="d-width text-primary cursor" :title="row.title">
                                        <span>{{row.title}}</span>
                                    </div>
                                </template>
                                <template #project="{ row }">
                                    <div class="d-width" :title="row.project_name || '-'">{{row.project_name || '-'}}</div>
                                </template>
                                <template #maintain="{ row }">
                                    <div class="d-width" :title="row.maintain_title || '-'">{{row.maintain_title || '-'}}</div>
                                </template>
                                <template #company="{ row }">
                                    <div class="d-width" :title="row.company || '-'">{{row.company || '-'}}</div>
                                </template>
                                <template #buyer_money="{ row }">
                                    <strong class="text-primary">{{row.buyer_money ? row.buyer_money : '0.00'}}</strong>
                                </template>
                                <template #pay_money="{ row }">
                                    <strong class="text-violet">{{row.pay_money ? row.pay_money : '0.00'}}</strong>
                                </template>
                                <template #product="{ row }">
                                    <Poptip trigger="hover" width="360" :word-wrap="true" title="产品价格：">
                                        <div class="d-width">
                                            <Tag v-for="(item,index) in row.product_list" :key="index">{{item.name}}</Tag>
                                        </div>
                                        <template #content>
                                            <p v-for="(item,index) in row.proList" :key="index" style="white-space: normal;">{{item.product_name}}：单价：{{item.price}}，数量：{{item.num}}</p>
                                        </template>
                                    </Poptip>
                                </template>
                                <template #status="{ row }">
                                    <Badge v-if="row.status === 1" color="blue" :text="row.status_name" />
                                    <Poptip v-else-if="row.status === 2" trigger="hover" width="240" :word-wrap="true" title="未通过原因：">
                                        <Badge color="red" :text="row.status_name" />
                                        <template #content>
                                            <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                                            <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                                        </template>
                                    </Poptip>
                                    <Badge v-else-if="row.status === 3" color="green" :text="row.status_name" />
                                    <Badge v-else status="warning" text="其他" />
                                </template>
                                <template #action="{ row }">
                                    <a class="text-font-sm text-orange" v-if="($store.state.userinfo.group_id == 1 || $store.state.userinfo.group_id == 2) && (row.status === 1 || row.status === 2)" @click="examineData(row.buyer_id, row.title)">审批</a>
                                    <Divider v-if="($store.state.userinfo.group_id == 1 || $store.state.userinfo.group_id == 2) && (row.status === 1 || row.status === 2)" type="vertical"/>
                                    <a class="text-font-sm text-primary" @click="editData(row.buyer_id)">编辑</a>
                                    <Divider type="vertical"/>
                                    <a class="text-font-sm text-999" @click="delData(row.buyer_id)">删除</a>
                                </template>
                            </Table>
                            <div class="em-page em-flex">
                                <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="changePage" />
                            </div>
                        </Col>
                    </Row>

                    <!-- 创建/编辑 -->
                    <buyer-create v-if="is_create" ref="AddRef" @trueHandler="getList"></buyer-create>
                    <!-- 审批 -->
                    <buyer-examine v-if="is_examine" ref="ExamineRef" @trueHandler="getList"></buyer-examine>

                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import BuyerCreate from "./BuyerCreate.vue";
import BuyerExamine from "./BuyerExamine.vue";
import {deleteSmallBuyer, getSmallBuyerConfig, getSmallBuyerList} from "@/apis/dispersed";

export default {
    name: "DispersedBuyer",
    components: {
        Headers, Side, BuyerCreate, BuyerExamine
    },
    data () {
        return {
            projectList: [],
            maintainList: [],
            companyList: [],
            productList: [],
            userList: [],
            statusList: [],

            search: {
                title: '',
                small_project_id: '',
                maintain_id: '',
                company_id: '',
                product: '',
                head_id: '',
                status: ''
            },
            page: 1,
            pageSize: 15,
            dataList: [],
            columns: [
                {title: '采购标题', key: 'title', slot: 'title', minWidth: 180},
                {title: '零星项目', key: 'project_name', slot: 'project', minWidth: 160},
                {title: '维保记录', key: 'maintain_title', slot: 'maintain', minWidth: 160},
                {title: '采购金额', key: 'buyer_money', slot: 'buyer_money', width: 110},
                {title: '合同金额', key: 'pay_money', slot: 'pay_money', width: 110},
                {title: '采购产品', key: 'product', slot: 'product', width: 180},
                {title: '状态', key: 'status', slot: 'status', width: 120},
                {title: '供应商', key: 'company',slot:'company', width: 150},
                {title: '负责人', key: 'head_name', width: 100},
                {title: '创建人', key: 'apply_name', width: 100},
                {title: '更新', key: 'update_time', width: 150},
                {title: '操作', key: 'action', slot: 'action', width: 150}
            ],
            is_create: false,
            is_examine: false
        }
    },
    created(){
        this.getConfig();
        this.getList();
    },
    mounted(){
        this.HeightInit();
    },
    methods: {
        examineData(buyer_id, title){
            this.is_examine = true;
            this.$nextTick(() => {
                this.$refs.ExamineRef.show(buyer_id, title);
            })
        },
        onSearch(){
            this.page = 1;
            this.getList();
        },
        reSet(){
            this.page = 1;
            this.search = {
                title: '',
                small_project_id: '',
                maintain_id: '',
                company_id: '',
                product: '',
                head_id: '',
                status: ''
            };
            this.getList();
        },
        getConfig(){
            getSmallBuyerConfig().then(e=>{
                this.projectList = e.data.projectList ?? [];
                this.maintainList = e.data.maintainList ?? [];
                this.companyList = e.data.companyList ?? [];
                this.productList = e.data.productList ?? [];
                this.userList = e.data.userList ?? [];
                this.statusList = e.data.statusList ?? [];
            })
        },
        getList(){
            const params = {
                pageSize: this.pageSize,
                page: this.page,
                search: this.search
            };
            this.$store.commit('SET_LOADING', true);
            getSmallBuyerList(params).then(e=>{
                this.dataList = e.data;
            })
        },
        changePage(e){
            this.page = e;
            this.getList();
        },
        createData(){
            this.is_create = true;
            this.$nextTick(() => {
                this.$refs.AddRef.add();
            })
        },
        editData(buyer_id){
            this.is_create = true;
            this.$nextTick(() => {
                this.$refs.AddRef.edit(buyer_id);
            })
        },
        delData(buyer_id){
            if(!buyer_id){
                this.$Message.error({ background: true, duration: 3, content: '记录不存在' });
                return;
            }
            this.$Modal.confirm({
                title: '删除记录',
                content: '此操作将删除记录不可恢复, 是否继续?',
                onOk: () => {
                    deleteSmallBuyer(buyer_id).then(e=>{
                        this.$Message.success({ background: true, duration: 3, content: e.msg });
                        this.getList();
                    })
                },
                onCancel: () => {}
            });
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT', window.innerHeight);
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT', window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
